/* Klarbrise – Verhalten aller NG-Abschnitte
   Galerie (Slide + Wischen), Kaufbereich (Stufen, Geschenke live, Abo-Preise, Tooltip, Sticky-Leiste),
   Fenster, Akkordeons (weich + exklusiv), Tabs, Karussells (Pfeile/Punkte), Zeitleiste, Formel-Scroll, Bewertungen.
   Reines Vanilla-JS, keine Netzwerkaufrufe, respektiert prefers-reduced-motion. */
(function(){
  if(window.__ngJs)return;window.__ngJs=1;
  var EASE='cubic-bezier(.2,.7,.2,1)';
  var mqRM=window.matchMedia?window.matchMedia('(prefers-reduced-motion: reduce)'):null;
  function rm(){return !!(mqRM&&mqRM.matches)}
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function arr(x){return [].slice.call(x)}
  function raf(fn){var q=0;return function(){if(q)return;q=1;requestAnimationFrame(function(){q=0;fn()})}}
  /* Fenster-Listener mit Aufräumen beim Neuladen eines Abschnitts im Theme-Editor */
  function on(root,t,ev,fn,opt){t.addEventListener(ev,fn,opt);(root.__ngOff=root.__ngOff||[]).push(function(){t.removeEventListener(ev,fn,opt)})}
  function weich(){return rm()?'auto':'smooth'}

  /* ---------- Galerie: Slide-Wechsel, Wischen, Pfeiltasten ---------- */
  function galerie(root){
    var box=root.querySelector('.ng-main'),main=box&&box.querySelector('img'),strip=root.querySelector('.ng-thumbs');
    var tb=arr(root.querySelectorAll('.ng-thumbs button'));
    if(!main||tb.length<2)return;
    var cur=0;tb.forEach(function(b,i){if(b.classList.contains('on'))cur=i;b.setAttribute('aria-label','Bild '+(i+1)+' von '+tb.length)});
    tb.forEach(function(b,i){b.setAttribute('aria-current',i===cur?'true':'false')});
    function swap(src,dir){
      if(rm()||!main.animate){main.style.translate='';main.src=src;main.removeAttribute('srcset');return}
      if(main.__a)main.__a.cancel();
      var out=main.animate([{opacity:1,transform:'none'},{opacity:0,transform:'translateX('+(-dir*3)+'%) scale(.985)'}],{duration:170,easing:'cubic-bezier(.4,0,1,1)',fill:'forwards'});
      main.__a=out;
      out.onfinish=function(){
        main.style.translate='';/* Ziehversatz vom Wischen: Bild ist hier unsichtbar (opacity 0) */
        main.src=src;main.removeAttribute('srcset');
        var rein=function(){out.cancel();main.__a=main.animate([{opacity:0,transform:'translateX('+(dir*4)+'%) scale(.985)'},{opacity:1,transform:'none'}],{duration:440,easing:EASE})};
        if(main.decode)main.decode().then(rein,rein);else rein();
      };
    }
    function show(i,dir){
      i=(i+tb.length)%tb.length;if(i===cur)return;
      if(dir==null)dir=i>cur?1:-1;
      cur=i;
      tb.forEach(function(x,j){x.classList.toggle('on',j===i);x.setAttribute('aria-current',j===i?'true':'false')});
      if(strip&&strip.scrollWidth>strip.clientWidth){var b=tb[i],l=strip.scrollLeft+b.getBoundingClientRect().left-strip.getBoundingClientRect().left-(strip.clientWidth-b.offsetWidth)/2;strip.scrollTo({left:l,behavior:weich()})}
      var src=tb[i].getAttribute('data-gross');if(!src){main.style.translate='';return}
      var pre=new Image(),fertig=0,go=function(){if(fertig)return;fertig=1;if(cur===i)swap(src,dir)};
      pre.onload=go;pre.onerror=function(){var fb=tb[i].getAttribute('data-gross-fb');if(fb&&src!==fb){src=fb;pre.onerror=go;pre.src=fb}else go()};pre.src=src;if(pre.complete)go();/* data-gross-fb: Original-JPG, falls die WebP-Datei fehlt (Speed 08.10.2026) */
      vor(i+1);
    }
    /* Vorschauen sind kleine Dateien – das große Bild erst laden, wenn Interesse erkennbar ist (Hover, Fokus, Wischbeginn) */
    var vg={};
    function vor(i){i=(i+tb.length)%tb.length;var s=tb[i]&&tb[i].getAttribute('data-gross');if(!s||vg[s])return;vg[s]=1;var im=new Image();im.decoding='async';im.src=s}
    tb.forEach(function(b,i){b.addEventListener('click',function(){show(i)});b.addEventListener('pointerenter',function(){vor(i)});b.addEventListener('focus',function(){vor(i)})});
    if(strip)strip.addEventListener('keydown',function(e){if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();show(cur+(e.key==='ArrowRight'?1:-1));tb[cur].focus()}});
    /* Wischen am Handy mit Achsen-Sperre (vertikales Scrollen bleibt frei: touch-action pan-y im CSS).
       touchstart merkt den Startpunkt. Im ersten touchmove über 8 px entscheidet die dominante Achse die GANZE Geste:
       horizontal (|dx| > |dy|) → preventDefault bis zum Loslassen (die Seite scrollt nicht), das Bild zieht mit;
       vertikal → die Galerie ignoriert die Geste, die Seite scrollt normal.
       Wechsel ab 40 px Weg oder bei schnellem Flick (> .45 px/ms). touchmove ist bewusst NICHT passiv. */
    var g=null,ZUG=.92;
    function zieh(f){main.style.translate=f+'px 0'}
    function zurueck(f){
      main.style.translate='';
      if(!f||rm()||!main.animate)return;
      main.animate([{translate:f+'px 0'},{translate:'0px 0'}],{duration:280,easing:EASE});
    }
    box.addEventListener('touchstart',function(e){
      if(e.touches.length!==1){g=null;return}
      var t=e.touches[0];
      g={x:t.clientX,y:t.clientY,m:0,dx:0,s:[{x:t.clientX,t:e.timeStamp}]};
      vor(cur+1);vor(cur-1);
    },{passive:true});
    box.addEventListener('touchmove',function(e){
      if(!g)return;
      if(e.touches.length!==1){if(g.m===1)zurueck(g.dx*ZUG);g=null;return}
      var t=e.touches[0],dx=t.clientX-g.x,dy=t.clientY-g.y;
      if(g.m===0){
        if(Math.abs(dx)<=8&&Math.abs(dy)<=8)return;
        /* Achse festlegen. Nicht abbrechbar = der Browser scrollt schon → vertikal behandeln */
        g.m=(Math.abs(dx)>Math.abs(dy)&&e.cancelable)?1:2;
      }
      if(g.m!==1)return;
      if(e.cancelable)e.preventDefault();
      g.dx=dx;var n=e.timeStamp;g.s.push({x:t.clientX,t:n});while(g.s.length>2&&n-g.s[0].t>110)g.s.shift();/* Zeit = Eingabezeit des Events (nicht Hauptthread-Takt) */
      zieh(clamp(dx*ZUG,-box.clientWidth*.7,box.clientWidth*.7));
    },{passive:false});
    function ende(abbruch){
      var h=g;g=null;if(!h||h.m!==1)return;
      var f=clamp(h.dx*ZUG,-box.clientWidth*.7,box.clientWidth*.7),a=h.s[0],b=h.s[h.s.length-1],v=b.t>a.t?(b.x-a.x)/(b.t-a.t):0;
      var richtung=h.dx<0?1:-1,gegen=Math.abs(v)>.3&&(v<0)!==(h.dx<0);
      var wechsel=!abbruch&&!gegen&&(Math.abs(h.dx)>=40||(Math.abs(v)>.45&&Math.abs(h.dx)>=14));
      if(wechsel){show(cur+richtung,richtung);setTimeout(function(){if(main.style.translate)zurueck(f)},600)}
      else zurueck(f);
    }
    box.addEventListener('touchend',function(){ende(false)},{passive:true});
    box.addEventListener('touchcancel',function(){ende(true)},{passive:true});
  }

  /* ---------- Kaufbereich: Stufen, Geschenke, Abo-Preise, Tooltip, Sticky-Leiste ---------- */
  function kauf(root){
    var hero=root.querySelector('.ng-hero');if(!hero)return;
    var form=hero.querySelector('form'),opts=arr(root.querySelectorAll('.ng-opt')),gifts=arr(root.querySelectorAll('.ng-gifts [data-ab]'));
    var abo=root.querySelector('.ng-abo input'),app=root.querySelector('.ng-app');
    /* Gewählte Stufe: Position der Variante bzw. der Bundle-Stufe der App (1, 2, 3 …), 0 = unbekannt */
    function stufe(){
      for(var i=0;i<opts.length;i++){var r=opts[i].querySelector('input');if(r&&r.checked)return i+1}
      if(app){
        var rs=arr(app.querySelectorAll('input[type=radio]')),c=null;
        rs.forEach(function(r){if(r.checked&&!c)c=r});
        if(c)return rs.filter(function(r){return r.name===c.name}).indexOf(c)+1;
        var sel=app.querySelector('[aria-checked="true"],[aria-selected="true"],[aria-pressed="true"]');
        if(sel&&sel.parentNode){var sib=arr(sel.parentNode.children).filter(function(x){return x.tagName===sel.tagName});var k=sib.indexOf(sel);if(k>=0)return k+1}
      }
      return 0;
    }
    function geschenke(){
      if(!gifts.length)return;var s=stufe();if(!s)return;
      gifts.forEach(function(g){
        var ab=+g.getAttribute('data-ab')||0,bis=+g.getAttribute('data-bis')||0;
        var an=s>=ab&&(!bis||s<=bis),ers=!!bis&&s>bis,war=g.classList.contains('on');
        g.classList.toggle('on',an);g.classList.toggle('ersetzt',ers);
        var em=g.querySelector('em');if(em)em.textContent=g.getAttribute(an?'data-frei':ers?'data-ers':'data-zu')||'';
        if(an&&!war&&!rm()){g.classList.remove('pop');void g.offsetWidth;g.classList.add('pop')}else if(!an)g.classList.remove('pop');
      });
    }
    gifts.forEach(function(g){g.addEventListener('animationend',function(){g.classList.remove('pop')})});
    var sticky=root.querySelector('.ng-sticky'),inf=null;
    if(sticky&&opts.length){inf=document.createElement('span');inf.className='inf';inf.innerHTML='<b></b><em></em>';sticky.insertBefore(inf,sticky.firstChild);sticky.classList.add('mit-inf')}
    function stickyInfo(){
      if(!inf)return;var o=null;opts.forEach(function(x){if(x.classList.contains('on'))o=x});if(!o)return;
      var b=o.querySelector('b'),pr=(form&&form.classList.contains('ng-abo-an')&&o.querySelector('.pa'))||o.querySelector('.pn');
      inf.firstChild.textContent=b?b.textContent:'';inf.lastChild.textContent=pr?pr.textContent:'';
    }
    function upd(){opts.forEach(function(o){var r=o.querySelector('input');o.classList.toggle('on',!!(r&&r.checked))});geschenke();stickyInfo()}
    if(form)form.addEventListener('change',upd);
    if(app)app.addEventListener('click',function(){setTimeout(upd,60)});
    if(abo&&form){var ab=function(){form.classList.toggle('ng-abo-an',abo.checked);stickyInfo()};abo.addEventListener('change',ab);ab()}
    upd();
    /* Sterne-Zeile springt weich zu den Bewertungen */
    var stars=root.querySelector('.ng-stars');
    if(stars){
      var ziel=function(){return document.querySelector('.ng-sum')||document.querySelector('.ng-revs')||document.querySelector('.ng-revapp')};
      if(ziel()){stars.setAttribute('role','link');stars.tabIndex=0;
        var hin=function(){var z=ziel();if(z)z.scrollIntoView({behavior:weich(),block:'center'})};
        stars.addEventListener('click',hin);stars.addEventListener('keydown',function(e){if(e.key==='Enter')hin()});}
    }
    /* Sticky-Kaufleiste: nur, wenn der Kaufknopf nach oben aus dem Bild gescrollt ist, nicht am Seitenende */
    if(sticky){
      var knopf=hero.querySelector('form .ng-atc')||hero.querySelector('form .ng-btn')||hero;
      var vis=function(){var r=knopf.getBoundingClientRect(),d=document.documentElement;var ende=window.innerHeight+window.pageYOffset>=d.scrollHeight-80,zeig=r.bottom<0&&!ende;sticky.classList.toggle('show',zeig);sticky.inert=!zeig};
      on(root,window,'scroll',raf(vis),{passive:true});on(root,window,'resize',raf(vis));vis();
      /* Klick springt zur Auswahl (Stufen/App + Kaufknopf), nicht zum Galerie-Anfang */
      var a=sticky.querySelector('a[href^="#"]');
      if(a)a.addEventListener('click',function(e){var t=form||document.getElementById(a.getAttribute('href').slice(1));if(!t)return;e.preventDefault();t.scrollIntoView({behavior:weich(),block:'start'})});
    }
  }

  /* ---------- Tooltip am ⓘ (Tippen am Handy, Hover/Fokus am Desktop; Tippen daneben schließt) ---------- */
  function tooltips(root){
    arr(root.querySelectorAll('.ng-tip')).forEach(function(t){
      t.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();t.classList.toggle('auf')});
      t.addEventListener('blur',function(){t.classList.remove('auf')});
    });
  }
  document.addEventListener('click',function(){arr(document.querySelectorAll('.ng-tip.auf')).forEach(function(t){t.classList.remove('auf')})});

  /* ---------- Fenster (dialog): weich auf/zu, Esc, Klick daneben ---------- */
  function zu(d){
    if(d.classList.contains('zu'))return;
    var fertig=function(){d.classList.remove('zu');if(d.close&&d.open)d.close();else d.removeAttribute('open');document.documentElement.classList.remove('ng-dlg-offen');if(d.__von&&d.__von.focus)d.__von.focus({preventScroll:true})};
    if(rm()){fertig();return}
    d.classList.add('zu');clearTimeout(d.__zt);d.__zt=setTimeout(fertig,230);
  }
  function auf(d,von){
    if(!d.__ng){d.__ng=1;
      d.addEventListener('click',function(e){if(e.target===d||(e.target.closest&&e.target.closest('[data-ng-close]')))zu(d)});
      d.addEventListener('cancel',function(e){e.preventDefault();zu(d)});
    }
    clearTimeout(d.__zt);d.__von=von;d.classList.remove('zu');
    if(d.showModal){if(!d.open)d.showModal()}else d.setAttribute('open','');
    document.documentElement.classList.add('ng-dlg-offen');
  }
  function dialoge(root){
    arr(root.querySelectorAll('[data-ng-modal]')).forEach(function(b){b.addEventListener('click',function(){var d=document.getElementById(b.getAttribute('data-ng-modal'));if(d)auf(d,b)})});
  }

  /* ---------- Akkordeons (Kaufbereich + FAQ): Höhe gleitet, Felder öffnen unabhängig ---------- */
  function klapp(d,offen){
    var s=d.querySelector('summary'),c=s&&s.nextElementSibling;
    if(d.__a){d.__a.cancel();d.__a=null}
    if(offen){
      /* 08.10.: andere Felder bleiben offen – sonst schrumpft Inhalt ueber der Zeile und die Seite springt */
      d.classList.add('auf');d.open=true;
      if(c&&c.animate&&!rm()){var h=c.scrollHeight;d.__a=c.animate([{height:'0px',opacity:0},{height:h+'px',opacity:1}],{duration:380,easing:EASE});d.__a.onfinish=function(){d.__a=null}}
    }else{
      d.classList.remove('auf');
      if(c&&c.animate&&!rm()&&d.open){var h2=c.offsetHeight;d.__a=c.animate([{height:h2+'px',opacity:1},{height:'0px',opacity:0}],{duration:260,easing:'cubic-bezier(.4,0,.2,1)'});d.__a.onfinish=function(){d.__a=null;if(!d.classList.contains('auf'))d.open=false}}
      else d.open=false;
    }
  }
  function akkordeons(root){
    arr(root.querySelectorAll('.ng-acc details, .ng-faq details')).forEach(function(d){
      var s=d.querySelector('summary');if(!s||d.__ac)return;d.__ac=1;
      d.classList.add('ac');if(d.open)d.classList.add('auf');
      s.addEventListener('click',function(e){e.preventDefault();klapp(d,!d.classList.contains('auf'))});
    });
  }

  /* ---------- Vergleich-Tabs: gleitende Pille, Inhalt blendet weich ein ---------- */
  function tabs(root){
    var bar=root.querySelector('.ng-tabs'),vt=arr(root.querySelectorAll('.ng-tabs button')),vp=arr(root.querySelectorAll('.ng-vsp'));
    var cur=0;vt.forEach(function(x,j){if(x.classList.contains('on'))cur=j});
    var ind=null;
    if(bar&&vt.length){
      bar.setAttribute('role','tablist');
      ind=document.createElement('span');ind.className='ng-ind';ind.setAttribute('aria-hidden','true');bar.insertBefore(ind,bar.firstChild);bar.classList.add('mit-ind');
      vt.forEach(function(b,j){b.setAttribute('role','tab');b.setAttribute('aria-selected',j===cur?'true':'false');b.tabIndex=j===cur?0:-1});
      vp.forEach(function(p){p.setAttribute('role','tabpanel')});
      bar.addEventListener('keydown',function(e){if(e.key!=='ArrowRight'&&e.key!=='ArrowLeft')return;e.preventDefault();var n=(cur+(e.key==='ArrowRight'?1:-1)+vt.length)%vt.length;root.__ngTab(n);vt[n].focus()});
    }
    function place(){if(!ind)return;var b=vt[cur];if(!b||!b.offsetWidth)return;ind.style.width=b.offsetWidth+'px';ind.style.height=b.offsetHeight+'px';ind.style.transform='translate('+b.offsetLeft+'px,'+b.offsetTop+'px)'}
    root.__ngTab=function(i,still){
      if(i<0||i>=vp.length)return;var alt=cur;cur=i;
      vt.forEach(function(x,j){x.classList.toggle('on',j===i);x.setAttribute('aria-selected',j===i?'true':'false');x.tabIndex=j===i?0:-1});
      vp.forEach(function(x,j){x.hidden=j!==i});
      place();
      if(alt!==i&&!still&&vp[i]&&vp[i].animate&&!rm())vp[i].animate([{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'none'}],{duration:460,easing:EASE});
      if(bar&&vt[i]&&bar.scrollWidth>bar.clientWidth)bar.scrollTo({left:vt[i].offsetLeft-(bar.clientWidth-vt[i].offsetWidth)/2,behavior:weich()});
    };
    vt.forEach(function(b,i){b.addEventListener('click',function(){root.__ngTab(i)})});
    if(ind){place();requestAnimationFrame(function(){requestAnimationFrame(function(){bar.classList.add('ind-bereit')})});
      on(root,window,'resize',raf(place));if(document.fonts&&document.fonts.ready)document.fonts.ready.then(place);
      if(window.ResizeObserver){var ro=new ResizeObserver(raf(place));ro.observe(bar);(root.__ngOff=root.__ngOff||[]).push(function(){ro.disconnect()})}}
  }

  /* ---------- FAQ-Kategorien: Fragen blenden versetzt ein ---------- */
  function faq(root){
    var ft=arr(root.querySelectorAll('.ng-ftabs button'));
    root.__ngKat=function(k){
      ft.forEach(function(x){x.classList.toggle('on',x.dataset.k===k);x.setAttribute('aria-pressed',x.dataset.k===k?'true':'false')});
      var n=0;
      arr(root.querySelectorAll('.ng-faq details')).forEach(function(d){
        var weg=d.dataset.k!==k,war=d.hidden;d.hidden=weg;
        if(!weg&&war&&d.animate&&!rm()){d.animate([{opacity:0,transform:'translateY(8px)'},{opacity:1,transform:'none'}],{duration:420,delay:n*45,easing:EASE,fill:'backwards'});n++}
      });
    };
    ft.forEach(function(b){b.setAttribute('aria-pressed',b.classList.contains('on')?'true':'false');b.addEventListener('click',function(){root.__ngKat(b.dataset.k)})});
  }

  /* ---------- Karussells: Pfeile (1 Karte, ausgegraut am Ende), anklickbare Punkte ----------
     Ziele sind die echten Rast-Stellen der Karten, auf das Scroll-Ende begrenzt (Ziele hinter dem Ende ließen
     weiches Scrollen mit scroll-snap teils ins Leere laufen).
     Ein Punkt je erreichbarer Stelle (am Desktop mit 3,6 sichtbaren Karten also weniger Punkte als Karten). */
  function karussell(root){
    arr(root.querySelectorAll('.ng-row, .ng-ba, .ng-revs')).forEach(function(row){
      if(row.__kr)return;row.__kr=1;
      var nav=row.classList.contains('ng-row')?root.querySelector('.ng-nav'):null;
      var prev=nav&&nav.querySelector('[data-dir="-1"]'),next=nav&&nav.querySelector('[data-dir="1"]');
      var dots=document.createElement('div');dots.className='ng-dots';dots.hidden=true;row.parentNode.insertBefore(dots,row.nextSibling);
      var ziel=null,zt=0;
      function karten(){return arr(row.children).filter(function(c){return c.offsetWidth>0})}
      function max(){return Math.max(0,row.scrollWidth-row.clientWidth)}
      function stellen(){
        var m=max(),x0=row.getBoundingClientRect().left+row.clientLeft+(parseFloat(getComputedStyle(row).scrollPaddingLeft)||0),p=[];
        karten().forEach(function(c){var v=clamp(Math.round(row.scrollLeft+c.getBoundingClientRect().left-x0),0,m);if(!p.length||v-p[p.length-1]>4)p.push(v)});
        return p.length?p:[0];
      }
      function idx(p){var s=row.scrollLeft,b=0,bd=1e9;p.forEach(function(v,i){var d=Math.abs(v-s);if(d<bd){bd=d;b=i}});return b}
      function zust(){
        var p=stellen(),i=idx(p),m=max(),s=row.scrollLeft,anf=s<=p[0]+4,end=s>=m-4;
        arr(dots.children).forEach(function(b,j){b.classList.toggle('on',j===i);b.setAttribute('aria-current',j===i?'true':'false')});
        if(prev)prev.disabled=anf;if(next)next.disabled=end;
        row.classList.toggle('am-anfang',anf);row.classList.toggle('am-ende',end);
        if(nav)nav.classList.toggle('leer',m<=4);
      }
      function fertig(){ziel=null;zust()}
      function hin(v){
        v=clamp(v,0,max());if(Math.abs(v-row.scrollLeft)<2)return;
        ziel=v;row.scrollTo({left:v,behavior:weich()});clearTimeout(zt);zt=setTimeout(fertig,600);
      }
      function geh(i){var p=stellen();hin(p[clamp(i,0,p.length-1)])}
      /* genau eine Karte weiter/zurück – auch bei schnellem Doppelklick (zählt vom laufenden Ziel aus) */
      function schritt(dir){
        var p=stellen(),s=ziel!==null?ziel:row.scrollLeft,t=null,i;
        if(dir>0){for(i=0;i<p.length;i++)if(p[i]>s+4){t=p[i];break}}
        else{for(i=p.length-1;i>=0;i--)if(p[i]<s-4){t=p[i];break}}
        if(t!==null)hin(t);
      }
      function bau(){
        var p=stellen();
        dots.hidden=p.length<2;
        if(dots.children.length!==p.length){dots.innerHTML='';p.forEach(function(v,i){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Ansicht '+(i+1)+' von '+p.length);b.addEventListener('click',function(){geh(i)});dots.appendChild(b)})}
        zust();
      }
      if(prev)prev.addEventListener('click',function(){schritt(-1)});
      if(next)next.addEventListener('click',function(){schritt(1)});
      row.addEventListener('scroll',raf(zust),{passive:true});
      row.addEventListener('scroll',function(){if(ziel!==null){clearTimeout(zt);zt=setTimeout(fertig,200)}},{passive:true});
      on(root,window,'resize',raf(bau));
      row.__ngBau=bau;bau();
      if(document.fonts&&document.fonts.ready)document.fonts.ready.then(bau);
      arr(row.querySelectorAll('img')).forEach(function(im){if(!im.complete)im.addEventListener('load',raf(bau))});
    });
  }

  /* ---------- Zeitleiste: Linie füllt sich, Knoten + Bild schalten an, wenn die Linie sie erreicht ---------- */
  function zeitleiste(root){
    var tl=root.querySelector('.ng-tl');if(!tl)return;
    var days=arr(tl.querySelectorAll('.ng-day'));tl.classList.add('ng-live');
    var f=function(){
      var r=tl.getBoundingClientRect(),fill=clamp(window.innerHeight*.6-r.top,0,r.height);
      tl.style.setProperty('--f',fill+'px');
      days.forEach(function(d){d.classList.toggle('on',d.offsetTop+4<=fill)});
    };
    on(root,window,'scroll',raf(f),{passive:true});on(root,window,'resize',raf(f));f();
  }

  /* ---------- Formel: Stück reagiert aufs Scrollen (Video spulen oder Bild drehen/heranzoomen), weich nachgezogen ---------- */
  function formel(root){
    var vid=root.querySelector('video.ng-scrub'),img=vid?null:root.querySelector('img.ng-piece'),el=vid||img;if(!el)return;
    var dur=0;
    if(vid){var md=function(){dur=vid.duration||0;if(ist>=0)malen()};vid.addEventListener('loadedmetadata',md);if(vid.readyState>=1)md()}
    if(rm()){if(vid){var ende=function(){if(vid.duration)vid.currentTime=Math.max(0,vid.duration-.05)};vid.addEventListener('loadedmetadata',ende);ende()}return}
    if(img)img.classList.add('scroll');
    var ziel=0,ist=-1,lauf=0,sicht=true;
    function malen(){
      if(vid){if(dur&&!vid.seeking){var t=ist*(dur-.05);if(Math.abs(vid.currentTime-t)>.03)vid.currentTime=t}}
      else{var e=1-Math.pow(1-ist,3);img.style.rotate=(-14*(1-e)).toFixed(2)+'deg';img.style.scale=(.86+.16*e).toFixed(3);img.style.translate='0 '+(36*(1-e)).toFixed(1)+'px';img.style.opacity=(.55+.45*Math.min(1,e*1.4)).toFixed(3)}
    }
    function tick(){ist+=(ziel-ist)*.12;if(Math.abs(ziel-ist)<.0015)ist=ziel;malen();if(ist!==ziel)requestAnimationFrame(tick);else lauf=0}
    function messen(){
      var r=el.getBoundingClientRect(),vh=window.innerHeight;
      ziel=clamp((vh*.9-r.top)/(vh*.5+r.height*.5),0,1);
      if(ist<0){ist=ziel;malen()}
      if(!lauf&&ist!==ziel){lauf=1;requestAnimationFrame(tick)}
    }
    if(vid)vid.addEventListener('seeked',function(){if(!lauf)malen()});
    var h=raf(messen);
    if('IntersectionObserver' in window){
      sicht=false;
      var io=new IntersectionObserver(function(es){es.forEach(function(e){sicht=e.isIntersecting;if(!sicht)return;messen();
        if(vid&&!vid.__an){vid.__an=1;var p=vid.play();if(p&&p.then)p.then(function(){vid.pause();messen()},function(){})}})},{rootMargin:'200px 0px'});
      io.observe(el);(root.__ngOff=root.__ngOff||[]).push(function(){io.disconnect()});
    }
    on(root,window,'scroll',function(){if(sicht)h()},{passive:true});on(root,window,'resize',h);messen();
  }

  /* ---------- Formel-Animation (reines CSS): pausiert, solange der Abschnitt nicht im Bild ist (spart Akku/CPU) ---------- */
  function fx(root){
    var st=root.querySelector('.ng-fx');if(!st||!('IntersectionObserver' in window))return;
    var io=new IntersectionObserver(function(es){es.forEach(function(e){st.classList.toggle('pause',!e.isIntersecting)})},{rootMargin:'60px 0px'});
    io.observe(st);(root.__ngOff=root.__ngOff||[]).push(function(){io.disconnect()});
  }

  /* ---------- Frost-Effekte (Start-Hero, Vergleich, Laufband): Bewegung startet erst NACH dem ersten Bild (Klasse „go“) und pausiert außerhalb des Bildschirms (Klasse „pause“). Reines CSS, hier nur der Schalter. ---------- */
  function frost(root){
    arr(root.querySelectorAll('[data-frost]')).forEach(function(el){
      var an=function(){el.classList.add('go')},img=el.querySelector('img');
      if(!img||img.complete)requestAnimationFrame(function(){requestAnimationFrame(an)});
      else{img.addEventListener('load',function(){requestAnimationFrame(an)},{once:true});img.addEventListener('error',an,{once:true});setTimeout(an,3000)}
      if('IntersectionObserver' in window){
        var io=new IntersectionObserver(function(es){es.forEach(function(e){el.classList.toggle('pause',!e.isIntersecting)})},{rootMargin:'80px 0px'});
        io.observe(el);(root.__ngOff=root.__ngOff||[]).push(function(){io.disconnect()});
      }
    });
  }

  /* ---------- Bewertungen: Mauerwerk-Raster (Desktop) + „Mehr laden“ ---------- */
  function bewertungen(root){
    var box=root.querySelector('.ng-revs');if(!box)return;
    var karten=arr(box.querySelectorAll('.ng-rev')),mehr=root.querySelector('.ng-more button'),n=parseInt(box.getAttribute('data-zeigen'),10)||0;
    var mq=window.matchMedia?window.matchMedia('(min-width: 861px)'):null;
    function mas(){
      var an=!!(mq&&mq.matches);box.classList.toggle('mas',an);
      karten.forEach(function(k){k.style.gridRowEnd=''});if(!an)return;
      karten.forEach(function(k){if(!k.offsetWidth)return;k.style.gridRowEnd='span '+Math.ceil(k.getBoundingClientRect().height+16)});
    }
    root.__ngMas=mas;
    if(mehr){
      if(n>0&&karten.length>n)karten.forEach(function(k,i){if(i>=n)k.classList.add('zu')});
      var rest=function(){return karten.filter(function(k){return k.classList.contains('zu')})};
      var knopf=function(){if(!rest().length)mehr.parentNode.classList.add('fertig')};
      mehr.addEventListener('click',function(){var r=rest();r.slice(0,n||r.length).forEach(function(k){k.classList.remove('zu')});mas();if(box.__ngBau)box.__ngBau();knopf()});
      knopf();
    }
    var m=raf(mas);
    karten.forEach(function(k){var i=k.querySelector('img');if(i&&!i.complete)i.addEventListener('load',m)});
    on(root,window,'resize',m);mas();
    if(document.fonts&&document.fonts.ready)document.fonts.ready.then(m);
  }

  /* ---------- Einblenden beim Scrollen ---------- */
  function einblenden(root){
    /* 08.10.: keine Einblend-Animation mehr – Bilder und Texte stehen sofort da */
    arr(root.querySelectorAll('.rv')).forEach(function(e){e.classList.add('in')});
  }

  function init(root){
    if(root.__ng)return;root.__ng=1;
    galerie(root);kauf(root);tooltips(root);dialoge(root);akkordeons(root);tabs(root);faq(root);
    einblenden(root);karussell(root);zeitleiste(root);formel(root);fx(root);frost(root);bewertungen(root);
  }
  function all(){arr(document.querySelectorAll('.ng')).forEach(init)}
  if(document.readyState!=='loading')all();else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',all);
  document.addEventListener('shopify:section:unload',function(e){
    var t=e.target;if(!t||!t.querySelectorAll)return;
    arr(t.querySelectorAll('.ng')).forEach(function(r){(r.__ngOff||[]).forEach(function(f){f()});r.__ngOff=[]});
  });
  /* Theme-Editor: angeklickten Block sichtbar machen (Tab, FAQ-Kategorie, Akkordeon, Karussell-Karte, versteckte Bewertung) */
  document.addEventListener('shopify:block:select',function(e){
    var t=e.target,root=t.closest&&t.closest('.ng');if(!root||!root.__ng)return;
    if(t.matches('.ng-vsp')&&root.__ngTab)root.__ngTab(arr(root.querySelectorAll('.ng-vsp')).indexOf(t),true);
    if(t.matches('.ng-faq details')){if(root.querySelector('.ng-ftabs')&&root.__ngKat)root.__ngKat(t.dataset.k);klapp(t,true)}
    if(t.matches('.ng-acc details'))klapp(t,true);
    if(t.matches('.ng-thumbs button'))t.click();
    if(t.matches('.ng-rev.zu')){arr(root.querySelectorAll('.ng-rev.zu')).forEach(function(x){x.classList.remove('zu')});if(root.__ngMas)root.__ngMas()}
    var row=t.parentNode;
    if(row&&row.matches&&row.matches('.ng-row,.ng-ba,.ng-revs')&&row.scrollWidth>row.clientWidth)row.scrollTo({left:row.scrollLeft+t.getBoundingClientRect().left-row.getBoundingClientRect().left});
    if(t.matches('.ng-day'))t.classList.add('on');
    t.classList.add('in');
  });
})();
